import LivestreamService from '@/services/LivestreamService';
export default {
  props: {
    limit: {
      type: Number,
      default: 0
    },
    channelId: {
      type: Number,
      default: 0
    },
    collapseable: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      loading: false,
      premieres: [],
      collapsed: true
    };
  },
  mounted: function () {
    this.init();
  },
  methods: {
    init: function () {
      this.loading = true;
      const data = {
        scheduletype: 2,
        groupbyvideo: true
      };
      if (this.limit && this.limit > 0) {
        data.limit = this.limit;
      }
      if (this.channelId && this.channelId !== 0) {
        data.channel_id = this.channelId;
      }
      LivestreamService.getSchedule(data).then(response => {
        this.premieres = response.data.results;
        this.$emit('listCount', this.premieres.length);
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  watch: {
    channelId: function (n, o) {
      if (n !== o) {
        this.init();
      }
    }
  }
};